/* eslint-disable import/prefer-default-export */
import { createAction } from 'redux-actions';
// Action Declarations
// Suggested Action Name Standard: ORG_MODULE_ACTION_ANY
export const setAppTitleAction = createAction('APP_SET_TITLE');
export const setAppDescriptionAction = createAction('APP_SET_DESCRIPTION');
